"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseConnectionHealthPolicy_1 = require("./BaseConnectionHealthPolicy");

var ReconnectionHealthPolicy = /*#__PURE__*/function (_BaseConnectionHealth) {
  _inherits(ReconnectionHealthPolicy, _BaseConnectionHealth);

  var _super = _createSuper(ReconnectionHealthPolicy);

  function ReconnectionHealthPolicy(logger, configuration, data) {
    var _this;

    _classCallCheck(this, ReconnectionHealthPolicy);

    _this = _super.call(this, configuration, data);
    _this.logger = logger;
    _this.audioDelayPointsOverMaximum = 0;
    ReconnectionHealthPolicy.CONNECTION_UNHEALTHY_THRESHOLD = configuration.connectionUnhealthyThreshold;
    ReconnectionHealthPolicy.CONNECTION_WAIT_TIME_MS = configuration.connectionWaitTimeMs;
    ReconnectionHealthPolicy.MISSED_PONGS_THRESHOLD = configuration.missedPongsUpperThreshold;
    ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_MS = configuration.maximumAudioDelayMs;
    ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_DATA_POINTS = configuration.maximumAudioDelayDataPoints;
    return _this;
  }

  _createClass(ReconnectionHealthPolicy, [{
    key: "health",
    value: function health() {
      var connectionStartedRecently = this.currentData.isConnectionStartRecent(ReconnectionHealthPolicy.CONNECTION_WAIT_TIME_MS);

      if (connectionStartedRecently) {
        return 1;
      }

      var noPacketsReceivedRecently = this.currentData.consecutiveStatsWithNoPackets >= ReconnectionHealthPolicy.CONNECTION_UNHEALTHY_THRESHOLD;
      var missedPongsRecently = this.currentData.consecutiveMissedPongs >= ReconnectionHealthPolicy.MISSED_PONGS_THRESHOLD;

      if (this.currentData.audioSpeakerDelayMs > ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_MS) {
        this.audioDelayPointsOverMaximum += 1;
      } else {
        this.audioDelayPointsOverMaximum = 0;
      }

      var hasBadAudioDelay = this.audioDelayPointsOverMaximum > ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_DATA_POINTS;

      if (hasBadAudioDelay) {
        this.audioDelayPointsOverMaximum = 0;
      }

      var needsReconnect = noPacketsReceivedRecently || missedPongsRecently || hasBadAudioDelay;

      if (needsReconnect) {
        this.logger.warn("reconnection recommended due to: no packets received: ".concat(noPacketsReceivedRecently, ", missed pongs: ").concat(missedPongsRecently, ", bad audio delay: ").concat(hasBadAudioDelay));
        return 0;
      }

      return 1;
    }
  }]);

  return ReconnectionHealthPolicy;
}(BaseConnectionHealthPolicy_1.default);

exports.default = ReconnectionHealthPolicy;